/*
  Used for taking two event handlers and running both of them.
    In DraggableList, this lets us keep the required handlers we get from react-beautiful-dnd,
    while also letting us call some custom handler on top of that.
*/

export default function combineEvents(_ch, _ph) {
  const customHandlers = _ch || {}
  const providedHandlers = _ph || {}

  return (eventName) => (e) => {
    if (customHandlers[eventName]) {
      customHandlers[eventName](e)
    }
    if (providedHandlers[eventName]) {
      providedHandlers[eventName](e)
    }
  }
}
